/**
 * GRANSKARE FÖR TODAY — chefens dagsvy ("Laget idag").
 *
 * DAGEN KOMMER UR SERVERKLOCKAN. Rutten bär request_in 'none': klienten skickar
 * inget datum, servern läser dagen i Europe/Stockholm och skickar tillbaka den i
 * work_date. Skärmen visar DEN dagen och aldrig sin egen idag() — en telefon som
 * står i fel tidszon ska inte kunna påstå att laget gäller en annan dag.
 *
 * "RAPPORTERAT" BETYDER MINST EN LEVANDE TIDRAD I DAG (beslut 06), oavsett vem
 * som skrev in den. Ingen incheckning finns, så listan är inte närvaro utan
 * rapportering — och den har ingenting med faktureringen att göra: beslut 18
 * räknar UPPLAGDA personer, aldrig rader.
 */

import type { TodayResponse } from '@delat/types';
import { accountId, arbetsdag, enAv, lista, minuter, nullbar, objekt, text } from '../granska';
import type { Granskare } from '../granska';
import { FRANVAROSLAG } from './arbetsorder';

const granskaRapporterad: Granskare<TodayResponse['reported'][number]> = (v) => {
  const o = objekt(v, 'reported[]');
  return {
    account_id: accountId(o['account_id'], 'reported[].account_id'),
    name: text(o['name'], 'reported[].name'),
    minutes: minuter(o['minutes'], 'reported[].minutes'),
  };
};

const granskaEjRapporterad: Granskare<TodayResponse['not_reported'][number]> = (v) => {
  const o = objekt(v, 'not_reported[]');
  return {
    account_id: accountId(o['account_id'], 'not_reported[].account_id'),
    name: text(o['name'], 'not_reported[].name'),
    absence: nullbar(o['absence'], 'not_reported[].absence', (x) =>
      enAv(x, 'not_reported[].absence', FRANVAROSLAG),
    ),
  };
};

export const granskaIdag: Granskare<TodayResponse> = (v) => {
  const o = objekt(v, 'today');
  return {
    work_date: arbetsdag(o['work_date'], 'today.work_date'),
    reported: lista(o['reported'], 'reported', granskaRapporterad),
    not_reported: lista(o['not_reported'], 'not_reported', granskaEjRapporterad),
  };
};
